import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';

export const MAPPING_LIST_MIN_TABLE_WIDTH = '18rem';

export interface MappingListGridProps {
  children: React.ReactNode;
  gridTemplateColumns: string;
  gridTestId: string;
  scrollTestId: string;
  minTableWidth?: string;
  sx?: SxProps<Theme>;
}

const MappingListGrid: React.FC<MappingListGridProps> = ({
  children,
  gridTemplateColumns,
  gridTestId,
  scrollTestId,
  minTableWidth = MAPPING_LIST_MIN_TABLE_WIDTH,
  sx,
}) => (
  <Box data-testid={scrollTestId} sx={[{ width: '100%', overflowX: 'auto' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
    <Grid
      data-testid={gridTestId}
      data-min-table-width={minTableWidth}
      sx={{ display: 'grid', gridTemplateColumns, width: '100%', minWidth: minTableWidth }}
    >
      {children}
    </Grid>
  </Box>
);

export default MappingListGrid;
